import { BaseResourceStorage } from '../../models/base-resource.storage';
import { Orgao } from '../comum/orgao.model';
import { Usuario } from '../comum/usuario.model';
import { Favorecido } from './favorecido.model';

export class FavorecidoCertificadoStorage extends BaseResourceStorage {
  constructor(
    public referencia_documento?: string,
    public situacao?: string,
    public data_vencimento?: Date,
    public favorecido?: Favorecido,
    public responsavel?: Usuario,
    public orgao?: Orgao,
    public editavel?: boolean,
    public arquivo?: any,
  ) {
    super();
  }

  static converteJson(json: any): FavorecidoCertificadoStorage {
    return Object.assign(new FavorecidoCertificadoStorage(), json);
  }
}
